import { useEffect, useRef } from "react";
import { useLocation } from "react-router";
import { Text } from "@ferrivia/ui";
import { useTranslation } from "@ferrivia/i18n";
import { ProfileMenu } from "../../components/ProfileMenu";
import { useInfusionSurface } from "../../hooks/useInfusionSurface";
import { useQuestionnaireSummaries } from "../../hooks/useQuestionnaireSummaries";
import { useRefetchOnOverlayClose } from "../../hooks/useRefetchOnOverlayClose";
import { SummaryList } from "../../summary/SummaryList";
import { InfusionSteps } from "./InfusionSteps";
import s from "./InfusionScreen.module.css";

export function InfusionScreen() {
  const { t } = useTranslation("client");
  const { state, refetch } = useInfusionSurface();
  const { state: summariesState, refetch: refetchSummaries } = useQuestionnaireSummaries();
  const summaries = summariesState.status === "success" ? summariesState.summaries : [];
  const { pathname } = useLocation();
  useRefetchOnOverlayClose(refetchSummaries);

  // Every tab panel stays mounted (app/TabPanels.tsx), so a step finished
  // elsewhere — a result added on the Results tab — would otherwise stay
  // stale until reload. Same became-active idiom as HomeScreen. The
  // questionnaire overlay sits over this tab without deactivating it, so a
  // screener submitted there needs its own refetch on close.
  const isActive = pathname === "/infusion";
  const wasActiveRef = useRef(isActive);
  useEffect(() => {
    if (isActive && !wasActiveRef.current) {
      refetch();
      refetchSummaries();
    }
    wasActiveRef.current = isActive;
  }, [isActive, refetch, refetchSummaries]);

  useRefetchOnOverlayClose(refetch);

  return (
    <>
      <div className={s.header}>
        <Text as="h1" size="xl" weight="bold" className={s.title}>
          {t("infusion.title", "Rautainfuusio")}
        </Text>
        <ProfileMenu className={s.profile} />
      </div>
      {state.status === "success" ? (
        <div className={s.body}>
          <InfusionSteps steps={state.surface.steps} summaries={summaries} refetch={refetch} />
          <SummaryList summaries={summaries} path="infusion" />
        </div>
      ) : null}
    </>
  );
}
